export default {
    backlog: [
        {
            title: 'Responsive bug',
            description: 'Etiam porta sem malesuada magna mollis euismod.',
        },
        {
            title: 'Travel checklist',
            description: 'Curabitur blandit tempus porttitor.',
        },
        {
            title: 'Budget review',
            description:
                'Cras justo odio, dapibus ac facilisis in, egestas eget quam. Integer posuere erat a ante venenatis dapibus posuere velit aliquet.',
            color: 'success',
        },
    ],
    todo: [
        {
            title: 'QA Testing',
            description: 'Etiam porta sem malesuada magna mollis euismod.',
        },
        {
            title: 'Layout design',
            description:
                'Sed posuere consectetur est at lobortis. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.',
            color: 'danger',
        },
        {
            title: 'Fix navigation menu',
            description: 'Donec sed odio dui.',
            color: 'info',
        },
        {
            title: 'Update bootstrap 4',
            description: 'Aenean lacinia bibendum nulla sed consectetur.',
        },
        {
            title: 'Run build tools',
            description:
                'Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum.',
        },
        {
            title: 'List article ideas',
            description:
                'Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.',
            color: 'success',
        },
        {
            title: 'Reactjs fixes',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
        },
        {
            title: 'Implement SSL',
            description: 'Etiam porta sem malesuada magna mollis euismod.',
            color: 'warning',
        },
        {
            title: 'Cleanup code',
            description: 'Sollicitudin',
            color: 'danger',
        },
    ],
    'In Process': [
        {
            title: 'QOS Assessment',
            description: 'Maecenas sed diam eget risus varius blandit sit amet non magna.',
        },
        {
            title: 'Schedule new tasks',
            description: 'Sed posuere consectetur est at lobortis.',
            color: 'warning',
        },
        {
            title: 'Add dashboard variants',
            description: 'Nulla vitae elit libero, a pharetra augue.',
        },
        {
            title: 'Extended color scheme support',
            description: 'Morbi leo risus, porta ac consectetur ac, vestibulum at eros.',
        },
        {
            title: 'Merge unit tests',
            description: 'Maecenas sed diam eget risus varius blandit sit amet non magna.',
            color: 'info',
        },
        {
            title: 'Test final version',
            description:
                'Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.',
        },
    ],
    'Currently in progress': [
        {
            title: 'Integrate Angular 4',
            description: 'Nulla vitae elit libero, a pharetra augue.',
        },
        {
            title: 'Additional fields',
            description: 'Donec id elit non mi porta gravida at eget metus.',
        },
        {
            title: 'Draggable task board',
            description: 'Sed posuere consectetur est at lobortis.',
            color: 'danger',
        },
        {
            title: 'Setup CI server',
            description: 'Maecenas faucibus mollis interdum.',
        },
        {
            title: 'Assign new tasks',
            description: 'Nullam quis risus eget urna mollis ornare vel eu leo.',
            color: 'success',
        },
        {
            title: 'Contact administrator',
            description:
                'Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum.',
        },
        {
            title: 'Commit changes',
            description: 'Aenean lacinia bibendum nulla sed consectetur.',
        },
    ],
    Complete: [
        {
            title: 'Store new files',
            description: 'Sed posuere consectetur est at lobortis.',
        },
        {
            title: 'Build landing page',
            description: 'Maecenas sed diam eget risus varius blandit sit amet non magna.',
        },
        {
            title: 'Setup basic layout',
            description: 'Vestibulum id ligula porta felis euismod semper.',
            color: 'info',
        },
        {
            title: 'Graphical fixes',
            description: 'Morbi leo risus, porta ac consectetur ac, vestibulum at eros.',
        },
        {
            title: 'Email alerts',
            description: 'Donec sed odio dui.',
        },
    ],
};
